import { Components, Theme } from '@mui/material/styles';

export default function MuiDialogContent(theme: Theme): Components['MuiDialogContent'] {
  return {
    styleOverrides: {
      root: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        paddingLeft: '56px',
        paddingRight: '56px',
      },
    },
  };
}
